// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"02304f66","131":"9bfd70a3","455":"0d9bcae2","532":"e981233b","834":"99781ae3","977":"c74814d9"}[chunkId] + ".chunk.js";
};